import * as React from 'react';

const NoSearchResultsIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="240"
      height="139.99"
      viewBox="0 0 240 139.99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="no-search-results-illustration"
    >
      <rect x="40" width="159.543" height="103.258" fill="#E6E8E9" />
      <rect
        x="44.3711"
        y="14.2803"
        width="150.801"
        height="83.4854"
        fill="white"
      />
      <rect x="40" width="159.543" height="7.68945" fill="#2969F2" />
      <ellipse
        cx="44.3711"
        cy="4.39439"
        rx="1.09276"
        ry="1.09849"
        fill="white"
      />
      <ellipse
        cx="49.8349"
        cy="4.39439"
        rx="1.09276"
        ry="1.09849"
        fill="white"
      />
      <ellipse
        cx="54.206"
        cy="4.39439"
        rx="1.09276"
        ry="1.09849"
        fill="white"
      />
      <rect
        x="58.5771"
        y="23.0684"
        width="38.2467"
        height="65.9095"
        fill="#E6E8E9"
      />
      <rect
        x="103.38"
        y="23.0684"
        width="31.6901"
        height="17.5759"
        fill="#2969F2"
      />
      <rect
        x="103.38"
        y="46.1367"
        width="31.6901"
        height="18.6744"
        fill="#E6E8E9"
      />
      <rect
        x="103.38"
        y="71.4023"
        width="31.6901"
        height="17.5759"
        fill="#E6E8E9"
      />
      <rect
        x="142.72"
        y="23.0684"
        width="38.2467"
        height="28.5608"
        fill="#E6E8E9"
      />
      <rect
        x="142.72"
        y="60.417"
        width="38.2467"
        height="28.5608"
        fill="#E6E8E9"
      />
      <path
        d="M166.76 52.7277V46.6249C166.76 42.1085 170.43 38.4473 174.956 38.4473C179.482 38.4473 183.152 42.1085 183.152 46.6249V52.7277C183.151 53.3341 182.659 53.8255 182.051 53.8262H167.861C167.253 53.8255 166.761 53.3341 166.76 52.7277Z"
        fill="#06103D"
      />
      <path
        d="M187.523 135.404L184.515 136.213L179.874 125.324L184.312 124.13L187.523 135.404Z"
        fill="#FCD3C9"
      />
      <path
        d="M181.786 135.311L187.431 133.741L188.415 137.314L179.215 139.873C178.954 138.926 179.078 137.913 179.561 137.057C180.043 136.202 180.843 135.574 181.786 135.311Z"
        fill="#06103D"
      />
      <path
        d="M156.925 137.312H153.964L152.555 125.229H156.926L156.925 137.312Z"
        fill="#FCD3C9"
      />
      <path
        d="M150.891 136.213H156.926V139.508H147.091C147.091 138.634 147.491 137.796 148.204 137.178C148.916 136.56 149.883 136.213 150.891 136.213Z"
        fill="#06103D"
      />
      <path
        d="M153.042 71.4856C153.467 72.1473 154.126 72.5579 154.84 72.6069C155.554 72.6559 156.25 72.3383 156.741 71.7394L164.575 75.7958L163.863 70.7229L156.533 67.6487C155.583 66.7458 154.198 66.803 153.307 67.7819C152.416 68.7608 152.302 70.3519 153.042 71.4856L153.042 71.4856Z"
        fill="#FCD3C9"
      />
      <path
        d="M169.989 98.8641C167.373 98.8641 164.665 98.4912 162.39 97.3821C159.947 96.2154 158.123 94.1277 157.355 91.6207C156.169 88.0269 157.665 84.4963 159.11 81.082C160.006 78.9663 160.853 76.968 161.072 74.9982L161.149 74.2989C161.491 71.1578 161.786 68.4451 163.422 67.4276C164.269 66.9002 165.409 66.8701 166.906 67.3354L180.967 71.7072L180.45 97.2538L180.364 97.2811C180.291 97.3048 175.334 98.8641 169.989 98.8641Z"
        fill="#06103D"
      />
      <path
        d="M167.399 58.5563C167.399 58.5563 173.801 56.5338 178.781 57.2922C178.781 57.2922 175.935 73.9778 176.884 79.5397C177.832 85.1016 160.405 81.6886 163.961 76.3795L165.147 70.0592C165.147 70.0592 162.776 67.5311 164.91 64.4974L167.399 58.5563Z"
        fill="#2969F2"
      />
      <path
        d="M162.902 98.8639L154.74 97.3095L157.59 75.0346C157.781 74.4128 162.195 60.2997 164.2 59.5361C165.656 59.0154 167.144 58.5953 168.656 58.2787L168.946 58.2197L167.31 60.7133L160.794 76.5722L162.902 98.8639Z"
        fill="#06103D"
      />
      <path
        d="M158.699 135.114L148.184 133.314L154.085 108.556L162.866 74.6973L162.953 75.2985C162.96 75.3433 163.78 79.7664 175.953 77.8038L176.06 77.7866L176.089 77.8937L190.801 131.303L178.819 133.354L167.89 94.3874L158.699 135.114Z"
        fill="#06103D"
      />
      <path
        d="M173.317 102.16L173.324 101.974C173.331 101.768 174.074 81.2144 173.826 72.9484C173.577 64.6543 176.316 57.4717 176.344 57.4001L176.366 57.3424L176.426 57.3254C179.97 56.3329 183.045 59.2951 183.075 59.3251L183.118 59.3674L182.109 67.5304L186.43 97.2142L173.317 102.16Z"
        fill="#06103D"
      />
      <ellipse
        cx="173.863"
        cy="48.8825"
        rx="6.01019"
        ry="6.04171"
        fill="#FCD3C9"
      />
      <path
        d="M164.575 48.1916C164.579 44.0254 167.482 40.6492 171.065 40.6445H172.29C175.873 40.6492 178.777 44.0254 178.781 48.1916V48.334H176.193L175.31 45.4599L175.133 48.334H173.796L173.35 46.8839L173.261 48.334H164.575V48.1916Z"
        fill="#06103D"
      />
      <path
        d="M172.436 55.5516C172.189 55.2034 172.155 54.7386 172.35 54.356C173.646 51.7961 175.462 47.0661 173.052 44.1491L172.879 43.9395H179.873V54.8412L173.52 56.005C173.455 56.0168 173.39 56.0228 173.325 56.0229C172.973 56.0229 172.642 55.8476 172.436 55.5516Z"
        fill="#06103D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.7101 14.4867C109.75 0.931908 130.263 -0.503872 144.035 11.2443C157.202 22.4768 159.739 41.9982 149.89 56.288L190.8 91.1843L190.805 91.1882C192.101 92.296 192.263 94.2563 191.168 95.5667C190.072 96.877 188.132 97.0412 186.836 95.9334L145.926 61.037C133.085 73.818 112.523 73.9763 99.4915 61.3945C86.4595 48.8127 85.6707 28.0415 97.7101 14.4867ZM106.186 55.9434C116.733 64.9401 132.498 63.5899 141.398 52.9277C145.672 47.8076 147.758 41.1809 147.199 34.5054C146.639 27.8299 143.48 21.6525 138.415 17.3322C127.867 8.33547 112.103 9.68562 103.203 20.3478C94.3035 31.01 95.6391 46.9467 106.186 55.9434Z"
        fill="#0F2658"
      />
      <path
        d="M175.183 82.3157C175.877 82.49 176.61 82.3396 177.186 81.905C177.761 81.4703 178.12 80.796 178.165 80.0636L186.43 77.7067L183.07 74.6973L175.737 77.3968C174.507 77.4005 173.474 78.3485 173.333 79.6035C173.192 80.8585 173.986 82.0237 175.183 82.3157Z"
        fill="#FCD3C9"
      />
      <path
        d="M178.219 81.2882L177.688 76.2752L184.98 72.2789L180.226 66.5623L181.002 60.1407L182.933 59.3184L182.994 59.3951C183.905 60.5586 191.894 70.7982 191.894 72.0639C191.894 73.364 190.365 77.182 188.274 78.2205C186.257 79.2223 178.683 81.1693 178.362 81.2518L178.219 81.2882Z"
        fill="#06103D"
      />
      <path
        d="M196.068 140H121.061C120.952 140 120.864 139.878 120.864 139.727C120.864 139.576 120.952 139.454 121.061 139.454H196.068C196.177 139.454 196.265 139.576 196.265 139.727C196.265 139.878 196.177 140 196.068 140Z"
        fill="#A4ACB0"
      />
    </svg>
  );
});

NoSearchResultsIllustration.displayName = 'NoSearchResultsIllustration';

export { NoSearchResultsIllustration };
